import React from "react";
import { Play, Clock } from "lucide-react";

export const VideoCard = ({ video }) => {
  const url = video.youtube_url || "";

  const handleOpen = (e) => {
    if (!url) {
      e.preventDefault();
      return;
    }
    // Try to open in a new tab; if blocked (sandboxed preview), navigate the top window.
    e.preventDefault();
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (!win) {
      try {
        window.top.location.href = url;
      } catch {
        window.location.href = url;
      }
    }
  };

  return (
    <a
      href={url || "#"}
      onClick={handleOpen}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`video-card-${video.id}`}
      className="group block cursor-pointer bg-white rounded-xl overflow-hidden border border-transparent hover:border-gold transition-all duration-300 hover:-translate-y-1"
      style={{ boxShadow: "0 8px 30px rgba(42,22,8,0.05)" }}
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brown-black/50 via-transparent to-transparent" />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="flex items-center justify-center w-14 h-14 rounded-full bg-gold/90 text-white backdrop-blur-sm scale-90 group-hover:scale-100 transition-transform duration-300 shadow-lg">
            <Play size={22} fill="currentColor" className="ml-0.5" />
          </span>
        </div>
        {video.duration && video.duration !== "—" && (
          <span className="absolute bottom-3 right-3 flex items-center gap-1 px-2 py-1 rounded-md bg-brown-black/70 text-ivory text-xs font-medium backdrop-blur-sm">
            <Clock size={12} /> {video.duration}
          </span>
        )}
      </div>
      <div className="p-5">
        <span className="text-[11px] uppercase tracking-[0.18em] text-gold font-semibold">{video.category}</span>
        <h3 className="font-heading text-xl font-medium text-brown-black mt-2 leading-snug group-hover:text-gold transition-colors duration-300">
          {video.title}
        </h3>
      </div>
    </a>
  );
};

export default VideoCard;
